import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import { styles } from '../../styles/form-styles';

class ScaleSettings extends React.Component {
    render() {
      const { classes } = this.props;
        return(
          <div>
            <InputLabel className={classes.inputLabel} htmlFor="scale">Scale:</InputLabel>
            <RadioGroup row
              aria-label="scale"
              name="scale"
              className={classes.group}
              value={this.props.scale}
              onChange={this.props.onChange}
            >
                <FormControlLabel value="auto" control={<Radio />} label="Auto" />
                <FormControlLabel value="log" control={<Radio />} label="Log" />
                <FormControlLabel value="linear" control={<Radio />} label="Linear" />
            </RadioGroup>  
          </div>
        )
    }
    
}

ScaleSettings.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
  export default withStyles(styles)(ScaleSettings);


// WEBPACK FOOTER //
// ./src/components/Settings/ScaleSettings.js